import { Checkbox, FormControlLabel, FormControlLabelProps } from "@mui/material";
import { FieldPath, FieldPathValue, useController } from "react-hook-form";
import { UseControllerProps } from "react-hook-form";

export interface FormCheckboxProps<TFieldValues extends object, TFieldName extends FieldPath<TFieldValues>>
	extends Omit<FormControlLabelProps, "name" | "value" | "control">,
		Pick<UseControllerProps<TFieldValues, TFieldName>, "control" | "name" | "rules"> {
	label: string;
}

export const FormCheckbox = <TFieldValues extends object, TFieldName extends FieldPath<TFieldValues>>(
	{
		name,
		control,
		rules,
		label,
		...other
	}: FormCheckboxProps<TFieldValues, TFieldName>) => {

	const { field } = useController({
		name,
		control,
		rules,
		defaultValue: false as FieldPathValue<TFieldValues, TFieldName>
	});

	const transformedField = {
		...field,
		onChange: (_: React.ChangeEvent<HTMLInputElement>, checked: boolean) =>
			field.onChange(checked)
	};

	return (
		<FormControlLabel
			label={label}
			{...other}
			control={
				<Checkbox
					{...transformedField}
					checked={field.value}
				/>
			}
		/>
	);
};